module.exports = __webpack_public_path__ + "static/GTAmerica-Medium-ef95ec153f36d468a9d038977653cf3c.woff";